<template>
  <div>

    <div class="row">
      <div class="col s12">
        <button class="btn-large margin-btn" @click="exportToPDF" :disabled="!imageSrc"
          :class="{ 'disabled-btn': !imageSrc }">
          {{ translation('btn.pagina.qrcode.001') }}
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col s12">

        <div id="pdf-content" class="image-fetcher">

          <div v-if="imageSrc" class="image-container">

            <h2>{{ translation('pagina.qrcode.001') }}</h2>

            <table style="width: 50%!important;">
              <thead>
                <tr>
                  <td> <i class="material-icons prefix">event</i> {{ translation('event.name.field') }} </td>
                  <td>{{ fullEventData.name }}</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><i class="material-icons prefix" id="select-icon-date_finish">today</i> {{
                    translation('event.date.field') }}</td>
                  <td>{{ formatDate(fullEventData.event_date_start) }}</td>
                </tr>
                <tr>
                  <td><i class="material-icons prefix" id="select-icon-date_finish">today</i> {{
                    translation('event.date.field.finish') }}</td>
                  <td>{{ formatDate(fullEventData.event_date_finish) }}</td>
                </tr>
                <tr>
                  <td> <i class="material-icons prefix" id="select-icon-location">pin_drop</i> {{
                    translation('location.event.field') }}</td>
                  <td>{{ fullEventData.location }}</td>
                </tr>
              </tbody>
            </table>

            <img :src="imageSrc" alt="QR Code dell'evento" class="fetched-image">
          </div>

          <div v-else-if="isLoading">
            <img src="@/assets/img/icons/loading.gif" class="loading" />
          </div>

          <div v-else-if="error" class="error-message">
            <p><i class="material-icons prefix" id="select-icon-location">sentiment_very_dissatisfied</i> {{
              translation('something.went.wrong') }}</p>
          </div>

          <div v-else>

          </div>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col s12">
        <button class="btn-large margin-btn" @click="exportToPDF" :disabled="!imageSrc"
          :class="{ 'disabled-btn': !imageSrc }">
          {{ translation('btn.pagina.qrcode.001') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import eventSetting from '@/store/eventSettings.js'
import useAuthStore from '@/store/authStore.js'
import html2pdf from 'html2pdf.js'
import translationStore from '@/store/translations'
// import loadingStore from '@/store/loading'

export default {
  name: 'ImageFetcher',
  data () {
    return {
      imageSrc: null,
      isLoading: false,
      error: null,
      apiUrl: 'ajax/qrgen.php',
      eventSetting: eventSetting,
      useAuthStore: useAuthStore,
      proxyUrl: 'ajax/img_proxy.php',
      emailrimanenti: 'N/A'
    }
  },

  computed: {
    fullEventData () {
      if (eventSetting && eventSetting.getters) {
        return eventSetting.getters.eventModel || {}
      }
      return {}
    },
    userUid () {
      return (useAuthStore && useAuthStore.getters) ? useAuthStore.getters.uid || null : null
    },

    translation () {
      return translationStore.getters.traduzione
    }
  },
  methods: {
    formatDate (dateString) {
      const format = this.fullEventData?.timezone?.time_format || 'YYYY-MM-DD'
      const tz = this.fullEventData?.timezone?.timezone_name || 'UTC'

      return this.$formatEventDate(dateString, format, tz)
    },

    async fetchImage () {
      this.isLoading = true
      this.error = null
      this.imageSrc = null

      const eventUid = this.fullEventData.uid
      const userUid = this.userUid

      if (!eventUid || !userUid) {
        this.isLoading = false
        this.error = 'UID evento o utente mancante.'
        return
      }

      const payload = { event_uid: eventUid, user_uid: userUid }

      try {
        const session = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        const url = this.apiUrl + '?control=' + session
        const response = await axios.post(url, payload, { responseType: 'blob', headers: { 'Content-Type': 'application/json' } })

        if (response.data instanceof Blob) {
          if (this.imageSrc) { URL.revokeObjectURL(this.imageSrc) }
          const objectURL = URL.createObjectURL(response.data)
          this.imageSrc = objectURL
        } else {
          this.error = "La risposta del server non è un'immagine binaria valida."
        }
      } catch (err) {
        console.error("Errore nel recupero dell'immagine:", err)
        this.error = 'Richiesta fallita. Controlla l\'endpoint PHP.'

        if (err.response) {
          this.error = `Errore API: ${err.response.status} - ${err.response.statusText}`
        }
      } finally {
        this.isLoading = false
      }
    },

    async exportToPDF () {
      const fileName = this.fullEventData.name.replaceAll(' ', '_') + '.pdf'
      const componentElement = document.getElementById('pdf-content')

      if (!componentElement) return

      const session = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      const externalImgSrc = this.proxyUrl + '?control=' + session

      const tempContainer = document.createElement('div')

      // 1. AGGIUNGI L'IMMAGINE ESTERNA (se presente)
      if (externalImgSrc) {
        const externalImg = document.createElement('img')
        externalImg.src = externalImgSrc
        externalImg.style.width = '100%'
        externalImg.style.marginBottom = '20px'

        tempContainer.appendChild(externalImg)
      }

      // 2. AGGIUNGI il CONTENUTO VISIBILE (#pdf-content)
      tempContainer.appendChild(componentElement.cloneNode(true))

      // 3. AGGIUNGI IL FOOTER CON GLI STILI RICHIESTI
      const footer = document.createElement('div')

      // ⭐ APPLICAZIONE DEGLI STILI RICHIESTI ⭐
      footer.style.backgroundColor = '#000'
      footer.style.textAlign = 'center'
      footer.style.color = '#fff'
      footer.style.fontSize = '.85em'
      footer.style.marginTop = '-20px' // Stile richiesto
      footer.style.paddingTop = '10px' // Stile richiesto
      footer.style.paddingBottom = '10px' // Stile richiesto

      const footerText = document.createElement('p')
      footerText.style.margin = '0' // Rimuove il margine di default del <p>

      // Testo del Footer
      footerText.textContent = 'copyright ©2025 Sì NO servizi srl. All rights reserved | P.IVA 02723031205'

      footer.appendChild(footerText)
      tempContainer.appendChild(footer)

      // 4. GENERA PDF dal CONTENITORE COMBINATO
      const options = {
        margin: 10,
        filename: fileName,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      }

      html2pdf().set(options).from(tempContainer).save()
    }

  },
  mounted () {
    this.fetchImage()
  },
  beforeUnmount () {
    if (this.imageSrc) {
      URL.revokeObjectURL(this.imageSrc)
    }
  }
}
</script>

<style scoped>
/* Stili esistenti */
.fetched-image {
  max-width: 100%;
  height: auto;
  border: 1px solid #000;
  padding: 5px;
}

.image-fetcher {
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  text-align: center;
}

.image-container {
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}

.error-message {
  border: 1px solid red;
  background-color: #ffe0e0;
  padding: 10px;
  margin-bottom: 15px;
}

.disabled-btn {
  background-color: #ccc;
  cursor: not-allowed;
}

.margin-btn {
  margin: auto !important;
}

/* ⭐ CORREZIONE CRITICA: Nasconde l'immagine con opacità, NON con display: none ⭐ */
.external-image-for-pdf {
  opacity: 0;
  /* Rende l'elemento invisibile, ma lo mantiene nel DOM per html2canvas */
  max-width: 100%;
  height: auto;
  margin-bottom: 15px;
}

/* ⭐ Regola per la stampa/PDF: Rende l'immagine completamente visibile ⭐ */
@media print {
  .external-image-for-pdf {
    opacity: 1 !important;
    /* Forza la visibilità nel PDF */
    visibility: visible !important;
  }
}
</style>
